@if (pagination.totalPages > 1) {
  <nav class="d-flex justify-content-center mt-4 mb-5" aria-label="Page navigation">
    <ul class="pagination pagination-md gap-2 m-0">
      <!-- Previous button -->
      <li class="page-item" [class.disabled]="!canGoPrevious">
        <button class="page-link page-link-arrow rounded-2 border-0 d-flex align-items-center justify-content-center px-3" 
                (click)="onPrevious()" 
                aria-label="Previous">
          <span aria-hidden="true">&lt;</span>
        </button>
      </li>

      <!-- Page numbers -->
      @for (page of visiblePages; track $index) {
        @if (page === -1) {
          <li class="page-item disabled">
            <span class="page-link rounded-2 border-0 bg-transparent px-2">…</span>
          </li>
        } @else {
          <li class="page-item" [class.active]="page === pagination.currentPage">
            <button class="page-link rounded-2 border-0 d-flex align-items-center justify-content-center" 
                    style="min-width: 40px; height: 40px;"
                    (click)="onPageClick(page)">
              {{ page }}
            </button>
          </li>
        }
      }

      <!-- Next button -->
      <li class="page-item" [class.disabled]="!canGoNext">
        <button class="page-link page-link-arrow rounded-2 border-0 d-flex align-items-center justify-content-center px-3" 
                (click)="onNext()" 
                aria-label="Next">
          <span aria-hidden="true">&gt;</span>
        </button>
      </li>
    </ul>
  </nav>
}
